import React, { useContext } from 'react';

import { GridRowParams, GridValueFormatterParams } from '@mui/x-data-grid';

import CustomDataGrid from '../../components/data-grid';
import { AppContext } from '../../contexts/app-context';
import GlobalStyles from '../../global-styles';
import { formatDateForDataGrid, goToRoutePage } from '../../utils/helper';
import { Box } from '../../utils/material-ui-core';

const ClientCompanyList = () => {
  const globalStyles = GlobalStyles();

  const { writeLog, clientCompanies } = useContext(AppContext);

  const columns = [
    { field: "name", headerName: "Client Company", width: 300, hide: false },
    { field: "hsbPartnerId", headerName: "Code", width: 150, hide: false },
    { field: "parentName", headerName: "Parent", width: 200, hide: true },
    { field: "shortName", headerName: "Short Name", width: 200, hide: true },
    {
      field: "addressline1",
      headerName: "Address Line 1",
      width: 200,
      hide: true,
    },
    {
      field: "addressline2",
      headerName: "Address Line 2",
      width: 200,
      hide: true,
    },
    { field: "locality1", headerName: "Locality 1", width: 150, hide: true },
    { field: "region1", headerName: "Region 1", width: 150, hide: true },
    { field: "postalCode", headerName: "Postal Code", width: 150, hide: true },
    { field: "country", headerName: "Country", width: 150, hide: false },
    {
      field: "active",
      headerName: "Active",
      width: 150,
      type: "boolean",
      hide: false,
    },
    {
      field: "changeProgram",
      headerName: "Change Program",
      width: 200,
      type: "boolean",
      hide: true,
    },
    {
      field: "enableEnlistment",
      headerName: "Enlistment",
      width: 150,
      type: "boolean",
      hide: true,
    },
    {
      field: "routingName",
      headerName: "Routing Name",
      width: 250,
      hide: true,
    },
    {
      field: "enlistmentSiteManageByAEM",
      headerName: "Manage By AEM",
      width: 150,
      type: "boolean",
      hide: true,
    },
    { field: "dcxSiteId", headerName: "AEM Site Id", width: 250, hide: true },
    {
      field: "programCount",
      headerName: "# Programs",
      width: 170,
      type: "number",
      hide: false,
    },
    {
      field: "enrollmentCount",
      headerName: "# Enrolled",
      width: 150,
      type: "number",
      hide: false,
    },
    {
      field: "lastModifiedBy",
      headerName: "Last Modified By",
      width: 250,
      hide: true,
    },
    {
      field: "lastModifiedDateTime",
      headerName: "Last Modified Date",
      width: 200,
      type: "dateTime",
      hide: false,
      valueFormatter: (params: GridValueFormatterParams) => formatDateForDataGrid(params.value as string),
    },
    { field: "clientCompanyKey", headerName: "Key", width: 350, hide: true },
  ];

  const handleDataGridClick = (params: GridRowParams, event: any) => {
    const path = "onboarding/clientcompanies/" + params.row.clientCompanyKey;
    writeLog("Onboarding Page", "Opening client company detail.", params.row.clientCompanyKey, "clientcompany");
    goToRoutePage(path);
  };

  const getData = () => {
    const rows: any = [];
    clientCompanies.map((clientCompany, index) =>
      rows.push({
        id: index,
        ...clientCompany,
        ...clientCompany.address,
      })
    );
    return rows;
  };

  return (
    <Box className={globalStyles.onboardingDatagridContainer}>
      <CustomDataGrid uniqueGridCode={"ClientCompanyListResult"} columns={columns} rows={getData()} showToolBar={true} sortModel={[{ field: "name", sort: "asc" }]} handleDataGridClick={handleDataGridClick} />
    </Box>
  );
};

export default ClientCompanyList;
